import { render, staticRenderFns } from "./Gift_TouSu.vue?vue&type=template&id=db127054&scoped=true"
import script from "./Gift_TouSu.vue?vue&type=script&lang=js"
export * from "./Gift_TouSu.vue?vue&type=script&lang=js"
import style0 from "./Gift_TouSu.vue?vue&type=style&index=0&id=db127054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db127054",
  null
  
)

export default component.exports